import React, { useEffect, useState } from "react";
import { Alert, Card, CardTitle, Label } from "reactstrap";
import {
  CREATE_DELIVERY_NOTE_API,
  RETRIEVE_INITAL_DELIVERY_NOTE_LOADING_ORDERS,
} from "../../../../../../../../api/api_data";
import { useDispatch, useSelector } from "react-redux";
import { employee_dashboard_actions_helper } from "../../../../../../../../actions/actions_helper";
import {
  RETRIEVE_LOADING_ORDER_LIST_ACCESS_DENIED_MSG,
  RETRIEVE_LOADING_ORDER_LIST_ERR_MSG,
  RETRIEVE_LOADING_ORDER_LIST_SUCCESS_MSG,
  CREATE_PHYSICAL_DELIVERY_NOTE_TICKET_ACCESS_DENIED_MSG,
  CREATE_PHYSICAL_DELIVERY_NOTE_TICKET_ERR_MSG,
  CREATE_PHYSICAL_DELIVERY_NOTE_TICKET_SUCCESS_MSG,
} from "../../../../../../../../constants/success_error_messages_consts";
import {
  fail_retrieve_loading_order_list,
  loading_retrieve_loading_order_list,
  reset_retrieve_loading_order_list,
  success_retrieve_loading_order_list,
} from "../../../../../../../../reducers/dashboard_reducers/loading_orders/retrieve_loading_order_list_Slice";
import {
  BlockHead,
  BlockTitle,
  Button,
  Col,
  Icon,
  Row,
  RSelect,
} from "../../../../../../../../components/Component";
import * as app_consts from "../../../../../../../../constants/react_app_consts";
import {
  capitalizeWords,
  retreive_rSelectVariables,
} from "../../../../../../../../utils/functionalUtils";
import { formatWeighbridgeWeightInputMt } from "../../../../../../../../utils/weighbridgeUtils";
import { resolveWeighbridgeTicketPrefillData } from "../../../../../../../../utils/weighbridgeTicketNormalization";
import { BiErrorCircle } from "react-icons/bi";
import ProfileDetailText from "../../../../../text/ProfileDetailText";
import TextInput from "../../../../../../../components/inputs/TextInput";
import {
  fail_create_delivery_note_ticket,
  loading_create_delivery_note_ticket,
  reset_create_delivery_note_ticket,
  success_create_delivery_note_ticket,
} from "../../../../../../../../reducers/dashboard_reducers/delivery_notes/create_delivery_note_ticket_Slice";
import { messageToast, rSelectMapFun } from "../../../../../../../../utils/Utils";

/**
 * FIX: include trailer_one + trailer_two because the UI uses them for BULK LOADING ORDER TYPE.
 * This keeps the existing flow stable.
 */
const initialState = {
  loading_order_ref_no: "",
  first_weight: "",
  comments: "",
  delivery_location: "",
  transporter_name: "",
  truck_driver_name: "",
  truck_license_plate: "",
  trailer_one: "",
  trailer_two: "",
  weighbridge_ticket_id: "",
  weigh_bridge_ticket_number: "",
  weigh_bridge_ticket_reference_no: "",
};

/**
 * NOTE:
 * - Existing flow remains manual.
 * - Weighbridge integration is optional and activates only if a ticket is passed in.
 * - When a ticket is selected => lock ALL weighbridge-driven fields.
 */
const SelectLoadingOrdersStep = ({
  nextStep,
  setWizardData,
  setWeighBridgeFormData,
  selectedWeighbridgeTicket,
}) => {
  const dispatch = useDispatch();

  const [loadingOrderList, setLoadingOrdersList] = useState(true);
  const [loadingOrderError, setLoadingOrderError] = useState("");
  const [loadingOrderData, setLoadingOrderData] = useState([]);
  const [loadingOrderDetails, setLoadingOrderDetails] = useState([]);
  const [loadingOrderSelect, setLoadingOrderSelect] = useState([]);
  const [formData, setFormData] = useState(initialState);
  const [errorVal, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [delivery_location_list, setDeliveryLocationList] = useState([]);

  // ======================================================
  // WEIGHBRIDGE INTEGRATION (SAFE)
  // Lock ALL weighbridge-driven fields when ticket exists
  // ======================================================
  const isWeighbridgeLocked = !!selectedWeighbridgeTicket;

  // Anything in here becomes read-only when a ticket is selected
  const LOCKED_FIELDS = [
    "first_weight",
    "truck_license_plate",
    "transporter_name",
    "truck_driver_name",
    "trailer_one",
    "trailer_two",
    "comments",
  ];

  useEffect(() => {
    retrieve_loading_order_list_func();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const retrieve_loading_order_list_func = () => {
    dispatch(
      employee_dashboard_actions_helper(
        loading_retrieve_loading_order_list,
        success_retrieve_loading_order_list,
        fail_retrieve_loading_order_list,
        RETRIEVE_LOADING_ORDER_LIST_ERR_MSG,
        RETRIEVE_LOADING_ORDER_LIST_SUCCESS_MSG,
        app_consts.GET,
        RETRIEVE_INITAL_DELIVERY_NOTE_LOADING_ORDERS,
        null,
        RETRIEVE_LOADING_ORDER_LIST_ACCESS_DENIED_MSG
      )
    );
  };

  // Listen to Loading Order Changes
  const retrieve_loading_order_list = useSelector(
    (state) => state.retrieve_loading_order_list.retrieve_loading_order_list
  );

  useEffect(() => {
    if (retrieve_loading_order_list.status !== app_consts.IDLE) {
      if (retrieve_loading_order_list.status === app_consts.LOADING) {
        setLoadingOrderError("");
        setLoadingOrdersList(true);
      } else {
        setLoadingOrdersList(false);
        if (retrieve_loading_order_list.status === app_consts.FAIL) {
          setLoadingOrderError(retrieve_loading_order_list.message);
          messageToast(RETRIEVE_LOADING_ORDER_LIST_ERR_MSG, app_consts.FAIL);
        } else if (retrieve_loading_order_list.status === app_consts.SUCCESS) {
          setLoadingOrderData(retrieve_loading_order_list.data);
        }
        dispatch(reset_retrieve_loading_order_list());
      }
    }
  }, [retrieve_loading_order_list, dispatch]);

  useEffect(() => {
    if (loadingOrderData) {
      handleLoadingOrderList(loadingOrderData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadingOrderData]);

  const handleLoadingOrderList = async () => {
    let mappedData = [];

    await Promise.all(
      loadingOrderData?.map(async (data_to_map) => {
        const { label, value } = retreive_rSelectVariables(
          app_consts.LOADING_ORDERS_LIST,
          data_to_map
        );
        const result = await rSelectMapFun(label, value);
        mappedData.push(result);
      })
    );

    setLoadingOrderSelect(mappedData);
  };

  const handleDeliveryLocations = async (loadingOrderData) => {
    let mappedData = [];

    await Promise.all(
      loadingOrderData?.delivery_locations?.map(async (data_to_map) => {
        const { label, value } = retreive_rSelectVariables(
          app_consts.DELIVERY_LOCATION_MAP,
          data_to_map
        );
        const result = await rSelectMapFun(label, value);

        const isDuplicate = mappedData.some(
          (item) => item.label === result.label && item.value === result.value
        );

        if (!isDuplicate) {
          mappedData.push(result);
        }
      })
    );

    setDeliveryLocationList(mappedData);
  };

  const handleLoadingOrderChange = (value) => {
    const filteredData = loadingOrderData?.filter(
      (data) => data?.loading_order_ref_no === value
    );
    setLoadingOrderDetails(filteredData[0]);
    handleDeliveryLocations(filteredData[0]);

    // keep weighbridge fields intact if locked; clear only what is safe
    setFormData((prev) => ({
      ...prev,
      loading_order_ref_no: value,
      // if not locked, reset weight as before
      first_weight: isWeighbridgeLocked ? prev.first_weight : "",
    }));
  };

  const handleFirstWeightBlur = () => {
    if (isWeighbridgeLocked) return;

    if (formData?.first_weight) {
      setFormData({
        ...formData,
        first_weight: parseFloat(formData.first_weight).toFixed(2),
      });
    }
  };

  const handleChange = (e) => {
    // hard guard: prevent editing locked fields even if UI component forgets disabled
    if (isWeighbridgeLocked && LOCKED_FIELDS.includes(e.target.name)) return;

    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // ======================================================
  // WEIGHBRIDGE INTEGRATION (SAFE)
  // Autofill + mirror into parent form state
  // ======================================================
  useEffect(() => {
    if (!selectedWeighbridgeTicket) return;

    const selectedTicketPrefill =
      resolveWeighbridgeTicketPrefillData(selectedWeighbridgeTicket);

    const selectedTicketId =
      selectedTicketPrefill?.weighbridge_ticket_id ||
      selectedWeighbridgeTicket?.weighbridge_ticket_id ||
      selectedWeighbridgeTicket?.weigh_bridge_ticket_id ||
      selectedWeighbridgeTicket?.id ||
      "";

    setFormData((prev) => ({
      ...prev,
      first_weight:
        formatWeighbridgeWeightInputMt(selectedWeighbridgeTicket?.first_weight) ||
        formatWeighbridgeWeightInputMt(selectedTicketPrefill?.first_weight) ||
        prev.first_weight,
      weighbridge_ticket_id: selectedTicketId,
      weigh_bridge_ticket_number:
        selectedTicketPrefill?.weigh_bridge_ticket_number ||
        selectedWeighbridgeTicket?.weigh_bridge_ticket_number ||
        selectedWeighbridgeTicket?.ticket_number ||
        prev.weigh_bridge_ticket_number,
      weigh_bridge_ticket_reference_no:
        selectedTicketPrefill?.weigh_bridge_ticket_reference_no ||
        selectedWeighbridgeTicket?.weigh_bridge_ticket_reference_no ||
        prev.weigh_bridge_ticket_reference_no,
      truck_license_plate:
        selectedTicketPrefill?.truck_licence_plate ||
        selectedWeighbridgeTicket?.truck_licence_plate ||
        selectedWeighbridgeTicket?.vehicle_number ||
        prev.truck_license_plate,
      transporter_name:
        selectedTicketPrefill?.transporter_name ||
        selectedWeighbridgeTicket?.transporter_name ||
        prev.transporter_name,
      truck_driver_name:
        selectedTicketPrefill?.truck_driver_name ||
        selectedWeighbridgeTicket?.truck_driver_name ||
        prev.truck_driver_name,
      trailer_one:
        selectedTicketPrefill?.trailer_one ||
        selectedWeighbridgeTicket?.trailer_one ||
        prev.trailer_one,
      trailer_two:
        selectedTicketPrefill?.trailer_two ||
        selectedWeighbridgeTicket?.trailer_two ||
        prev.trailer_two,
      comments:
        selectedTicketPrefill?.comments ||
        selectedWeighbridgeTicket?.comments ||
        prev.comments,
    }));

    if (setWeighBridgeFormData) {
      setWeighBridgeFormData((prev) => ({
        ...prev,
        weighbridge_ticket_id: selectedTicketId,
        weigh_bridge_ticket_number:
          selectedTicketPrefill?.weigh_bridge_ticket_number ||
          selectedWeighbridgeTicket?.weigh_bridge_ticket_number ||
          selectedWeighbridgeTicket?.ticket_number,
        truck_license_plate:
          selectedTicketPrefill?.truck_licence_plate ||
          selectedWeighbridgeTicket?.truck_licence_plate ||
          selectedWeighbridgeTicket?.vehicle_number ||
          prev.truck_license_plate,
        first_weight:
          formatWeighbridgeWeightInputMt(selectedWeighbridgeTicket?.first_weight) ||
          formatWeighbridgeWeightInputMt(selectedTicketPrefill?.first_weight) ||
          prev.first_weight,
        second_weight:
          formatWeighbridgeWeightInputMt(selectedWeighbridgeTicket?.second_weight) ||
          formatWeighbridgeWeightInputMt(selectedTicketPrefill?.second_weight) ||
          prev.second_weight,
        net_weight:
          formatWeighbridgeWeightInputMt(selectedWeighbridgeTicket?.net_weight) ||
          formatWeighbridgeWeightInputMt(selectedTicketPrefill?.net_weight) ||
          prev.net_weight,
        weighbridge_locked: true,
        weighbridge_ticket_data:
          selectedWeighbridgeTicket ||
          selectedTicketPrefill?.weighbridge_ticket_data,
      }));
    }
  }, [selectedWeighbridgeTicket, setWeighBridgeFormData]);

  const handleCreateDN = () => {
    setError("");
    const payload = {
      ...formData,
      weighbridge_ticket_id: formData?.weighbridge_ticket_id || "",
      weigh_bridge_ticket_number: formData?.weigh_bridge_ticket_number || "",
      weigh_bridge_ticket_reference_no: formData?.weigh_bridge_ticket_reference_no || "",
    };

    dispatch(
      employee_dashboard_actions_helper(
        loading_create_delivery_note_ticket,
        success_create_delivery_note_ticket,
        fail_create_delivery_note_ticket,
        CREATE_PHYSICAL_DELIVERY_NOTE_TICKET_ERR_MSG,
        CREATE_PHYSICAL_DELIVERY_NOTE_TICKET_SUCCESS_MSG,
        app_consts.POST,
        CREATE_DELIVERY_NOTE_API,
        payload,
        CREATE_PHYSICAL_DELIVERY_NOTE_TICKET_ACCESS_DENIED_MSG
      )
    );
  };

  const create_delivery_note_ticket = useSelector(
    (state) => state.create_delivery_note_ticket.create_delivery_note_ticket
  );

  useEffect(() => {
    if (create_delivery_note_ticket.status !== app_consts.IDLE) {
      if (create_delivery_note_ticket.status === app_consts.LOADING) {
        setError("");
        setLoading(true);
      } else {
        setLoading(false);
        if (create_delivery_note_ticket.status === app_consts.FAIL) {
          setError(create_delivery_note_ticket.message);
          messageToast(create_delivery_note_ticket.message, app_consts.FAIL);
        } else if (create_delivery_note_ticket.status === app_consts.SUCCESS) {
          setWizardData(create_delivery_note_ticket.data);
          messageToast(CREATE_PHYSICAL_DELIVERY_NOTE_TICKET_SUCCESS_MSG, app_consts.SUCCESS);
          nextStep();
        }
        dispatch(reset_create_delivery_note_ticket());
      }
    }
  }, [create_delivery_note_ticket, dispatch, nextStep, setWizardData]);

  return (
    <>
      <Card className="card-inner">
        <CardTitle tag="h5">Select Loading Order</CardTitle>

        {isWeighbridgeLocked ? (
          <div className="alert alert-info mt-2">
            This Delivery Note is linked to a Weighbridge ticket. Weighbridge fields are locked.
          </div>
        ) : null}

        <Row className="g-4">
          <div className="mt-4 mb-4"></div>

          <Col size={6} className="my-2">
            <div className="form-group">
              <label className="form-label" htmlFor="uom">
                Loading Order
              </label>
              <div className="w-100 form-control-wrap d-flex flex-row justify-content-between align-items-center">
                <div className="w-100">
                  <RSelect
                    options={loadingOrderSelect}
                    className="w-100"
                    placeholder="Search"
                    id="loading_order_ref_no"
                    onChange={(e) => handleLoadingOrderChange(e.value)}
                    isDisabled={loadingOrderList}
                  />
                </div>
              </div>
            </div>
          </Col>

          <hr />

          <BlockHead>
            <BlockTitle tag="h6">Loading Order Details</BlockTitle>
          </BlockHead>

          {formData.loading_order_ref_no ? (
            <>
              <div className="profile-ud-list">
                <ProfileDetailText label="Owner" text={loadingOrderDetails?.owner || "---"} />
                <ProfileDetailText label="Contact person" text={loadingOrderDetails?.contact_person || "---"} />
                <ProfileDetailText label="Contact Mobile" text={loadingOrderDetails?.contact_mobile || "---"} />
                <ProfileDetailText
                  label="Loading Order Type"
                  text={loadingOrderDetails?.loading_order_type ? capitalizeWords(loadingOrderDetails?.loading_order_type) : "---"}
                />
                {loadingOrderDetails?.loading_order_type !== app_consts.BULK_L0ADING_ORDER_TYPE && (
                  <>
                    <ProfileDetailText label="Transporter" text={loadingOrderDetails?.transporter_name || "---"} />
                    <ProfileDetailText label="Truck Driver Name" text={loadingOrderDetails?.truck_driver_name || "---"} />
                    <ProfileDetailText label="Truck Reg No" text={loadingOrderDetails?.truck_license_plate || "---"} />
                    <ProfileDetailText label="Trailer One" text={loadingOrderDetails?.trailer_one_no || "---"} />
                    <ProfileDetailText label="Trailer Two" text={loadingOrderDetails?.trailer_two_no || "---"} />
                  </>
                )}
              </div>

              <hr />

              {loadingOrderDetails?.loading_order_type === app_consts.BULK_L0ADING_ORDER_TYPE && (
                <>
                  <BlockHead>
                    <BlockTitle tag="h6">Truck Details</BlockTitle>
                  </BlockHead>

                  <TextInput
                    colSize={5}
                    label="Transporter"
                    type="text"
                    id_val="transporter_name"
                    value={formData.transporter_name}
                    handleChange={handleChange}
                    name="transporter_name"
                    required
                    disabled={isWeighbridgeLocked}
                  />

                  <TextInput
                    colSize={5}
                    label="Truck Driver"
                    type="text"
                    id_val="truck_driver_name"
                    value={formData.truck_driver_name}
                    handleChange={handleChange}
                    name="truck_driver_name"
                    required
                    disabled={isWeighbridgeLocked}
                  />

                  <TextInput
                    colSize={5}
                    label="Truck Reg No"
                    type="text"
                    id_val="truck_license_plate"
                    value={formData.truck_license_plate}
                    handleChange={handleChange}
                    name="truck_license_plate"
                    required
                    disabled={isWeighbridgeLocked}
                  />

                  <TextInput
                    colSize={5}
                    label="Trailer Reg 1 (Optional)"
                    type="text"
                    id_val="trailer_one"
                    value={formData.trailer_one}
                    handleChange={handleChange}
                    name="trailer_one"
                    disabled={isWeighbridgeLocked}
                  />

                  <TextInput
                    colSize={5}
                    label="Trailer Reg 2 (Optional)"
                    type="text"
                    id_val="trailer_two"
                    value={formData.trailer_two}
                    handleChange={handleChange}
                    name="trailer_two"
                    disabled={isWeighbridgeLocked}
                  />

                  <hr />
                </>
              )}

              <BlockHead>
                <BlockTitle tag="h6">Branch Location | Weight Bridge Readings</BlockTitle>
              </BlockHead>

              <Col size={6}>
                <div className="form-group">
                  <label className="form-label" htmlFor="uom">
                    Delivery Location
                  </label>
                  <div className="w-100 form-control-wrap d-flex flex-row justify-content-between align-items-center">
                    <div className="w-100">
                      <RSelect
                        options={delivery_location_list}
                        className="w-100"
                        placeholder="Search"
                        id="delivery_location"
                        onChange={(e) => setFormData({ ...formData, delivery_location: e.value })}
                        isDisabled={loadingOrderList}
                      />
                    </div>
                  </div>
                </div>
              </Col>

              <TextInput
                colSize={6}
                label="Tare Weight (Metric Tonnes)"
                type="number"
                id_val="first_weight"
                value={formData.first_weight}
                handleChange={handleChange}
                name="first_weight"
                onBlur={handleFirstWeightBlur}
                disabled={isWeighbridgeLocked}
              />

              <Col sm="10" className="my-2">
                <div className="form-group">
                  <Label htmlFor="default-textarea" className="form-label">
                    WeighBridge Ticket Comments (Optional)
                  </Label>
                  <div className="form-control-wrap">
                    <textarea
                      className="no-resize form-control"
                      type="textarea"
                      id="default-textarea"
                      value={formData.comments}
                      disabled={isWeighbridgeLocked}
                      onChange={(e) => setFormData({ ...formData, comments: e.target.value })}
                    />
                  </div>
                </div>
              </Col>

              {errorVal && (
                <div className="mt-4">
                  <Alert color="danger" className="alert-icon">
                    <Icon name="alert-circle" />
                    {errorVal}
                  </Alert>
                </div>
              )}

              <Col xl="12" className="d-flex justify-content-end">
                <Button
                  onClick={handleCreateDN}
                  size="lg"
                  type="submit"
                  color="primary"
                  disabled={
                    loading ||
                    loadingOrderDetails?.loading_order_type !== app_consts.BULK_L0ADING_ORDER_TYPE
                      ? !(formData.loading_order_ref_no && formData.first_weight && formData.delivery_location)
                      : !(
                          formData.loading_order_ref_no &&
                          formData.first_weight &&
                          formData.delivery_location &&
                          formData.transporter_name &&
                          formData.truck_driver_name &&
                          formData.truck_license_plate
                        )
                  }
                >
                  Generate Delivery Note
                </Button>
              </Col>
            </>
          ) : (
            <div className="mb-2 text-soft alert-icon text-center fw-bold fs-15px">
              <BiErrorCircle className="text-warning fs-13" />
              <p>Select a loading Order to View Details</p>
            </div>
          )}
        </Row>
      </Card>
    </>
  );
};

export default SelectLoadingOrdersStep;
